module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customSize":"Custom size","selectAll":"Select all","popular":"Popular"},"ru":{"customSize":"Свой размер","selectAll":"Выбрать все","popular":"Популярные"}}')
  delete Component.options._Ctor
}
